import React from "react";
// import ServicesCard from '../../components/ServicesCard/ServicesCard';
// import { DefaultFlexCenter } from '../../Assistant/DefaultStyle';
// import SectionPayment from '../../components/SectionPayment/SectionPayment';
// import { setActiveUser, setUserLogoutState } from '../../features/userSlice.js';
// import { useDispatch } from 'react-redux';
// import { auth } from '../../firebase';
// import { DualRing } from 'react-awesome-spinners';
// import { useNavigate } from 'react-router-dom';
import SliderImage from "../../components/SliderImage/SliderImage";
import TitleServices from "../../components/TitleServices/TitleServices";
import FontsDefault from "../../Assistant/DefaultStyle";
import Footer from "../../components/Footer/Footer";
import { motion } from "framer-motion";
function OurServices() {
  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const [loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const getData = () => {
  //     auth.onAuthStateChanged((authUser) => {
  //       if (authUser) {
  //         setLoading(true);
  //         dispatch(
  //           setActiveUser({
  //             userName: authUser.displayName,
  //             userEmail: authUser.email,
  //           })
  //         );
  //         setLoading(false);
  //       } else {
  //         setLoading(true);
  //         dispatch(setUserLogoutState());
  //         navigate('/login');
  //         setLoading(false);
  //       }
  //     });
  //   };
  //   getData();
  // }, [dispatch, loading, navigate]);

  // <div className='flex justify-center items-center h-screen w-full'>
  //         <DualRing size={100} color='#22c55e' />
  //       </div>

  return (
    <motion.div
      initial={{ width: 0, opacity: 0 }}
      animate={{ width: "100vw", opacity: 1 }}
      exit={{ width: window.innerWidth, opacity: 0, transition: { duration: 0.1 } }}
    >
      <SliderImage />

      <div className={`${FontsDefault.defaultContainerWidth}`}>
        <TitleServices
          title="خدماتنا"
          description="ما هي الخدمات التي نقدمها لعملائنا الكرام"
          showBtn={true}
        />
        <div
          className={`md:grid-cols-3 grid-cols-1 md:w-full w-[90%] mx-auto ${FontsDefault.defaultGridContainer}`}
        >
          <img
            src="https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/%D8%A8%D9%86%D8%B1%D8%A7%D8%AA-07.png?alt=media&token=6cba1859-1e9e-47b9-b1ec-c6d04f95f0c3"
            alt="img"
            className="shadow-md shadow-gray300"
          />

          <img
            src="https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/%D8%A8%D9%86%D8%B1%D8%A7%D8%AA-08.png?alt=media&token=9a479e9a-e8c1-4dd2-a263-9c3fc012a2e7"
            alt="img"
            className="shadow-md shadow-gray300"
          />

          <img
            src="https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/%D8%A8%D9%86%D8%B1%D8%A7%D8%AA-09.png?alt=media&token=bba8d504-97fc-4b98-9bdc-33221efc0a1b"
            alt="img"
            className="shadow-md shadow-gray300"
          />

          <img
            src="https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/%D8%A8%D9%86%D8%B1%D8%A7%D8%AA-10.png?alt=media&token=daeae9c2-2f7f-49e2-aa9e-8d07d50bfae7"
            alt="img"
            className="shadow-md shadow-gray300"
          />

          <img
            src="https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/%D8%A8%D9%86%D8%B1%D8%A7%D8%AA-11.png?alt=media&token=6af74baf-bc6b-44b7-aadf-6d3f050d90ca"
            alt="img"
            className="shadow-md shadow-gray300"
          />

          <img
            src="https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/%D8%A8%D9%86%D8%B1%D8%A7%D8%AA-12.png?alt=media&token=088592b3-06b7-42cb-b9ab-efc4aec84dc2"
            alt="img"
            className="shadow-md shadow-gray300"
          />

          <img
            src="https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/%D8%A8%D9%86%D8%B1%D8%A7%D8%AA-13.png?alt=media&token=9ce1969f-67e2-4290-9d8e-9f4641ef4837"
            alt="img"
            className="shadow-md shadow-gray300"
          />

          <img
            src="https://firebasestorage.googleapis.com/v0/b/full-mark-app.appspot.com/o/%D8%A8%D9%86%D8%B1%D8%A7%D8%AA-14.png?alt=media&token=1e63fb63-d37c-4f70-b411-da32962977c2"
            alt="img"
            className="shadow-md shadow-gray300"
          />
        </div>
      </div>

      <Footer />
    </motion.div>
  );
}

export default OurServices;

// <ServicesCard />

// <div className={`bg-gray700 h-40 ${DefaultFlexCenter} items-center`}>
//             <h1 className={`${FontsDefault.text2xl} font-bold text-textColor`}>
//               تقدم الان لعملية الدفع
//             </h1>
//           </div>

//           <SectionPayment />
